import React from 'react';
import { Area, AreaChart, CartesianGrid, Line, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import type { Worker } from '../../engine/data';
import { AXIS_PROPS, GRID_PROPS, NO_ANIM, TOOLTIP_PROPS } from '../../chartTheme';
import { Grid, Panel } from '../../ui';

const WEEKS = Array.from({ length: 12 }, (_, i) => `W${i + 31}`);
const DAYS = ['M', 'T', 'W', 'T', 'F', 'S', 'S'];

export const TrendCharts: React.FC<{ w: Worker }> = ({ w }) => {
  const fedData = (w.fed12 ?? []).map((v, i) => ({ x: WEEKS[i], fed: v }));
  const slpData = w.slp7 ? w.slp7.map((v, i) => ({ x: DAYS[i], sleep: v, base: w.slp_b })) : [];

  return (
    <Grid cols={2}>
      <Panel title='FED Trend — 12 Weeks'>
        <div className='h-40'>
          <ResponsiveContainer width='100%' height='100%'>
            <AreaChart data={fedData} margin={{ top: 5, right: 8, bottom: 0, left: -16 }}>
              <CartesianGrid {...GRID_PROPS} />
              <XAxis dataKey='x' {...AXIS_PROPS} />
              <YAxis domain={[0, 100]} {...AXIS_PROPS} />
              <Tooltip {...TOOLTIP_PROPS} />
              <Area
                type='monotone'
                dataKey='fed'
                name='FED'
                stroke='var(--color-destructive)'
                fill='var(--color-destructive)'
                fillOpacity={0.1}
                strokeWidth={2}
                {...NO_ANIM}
              />
            </AreaChart>
          </ResponsiveContainer>
        </div>
      </Panel>
      <Panel title='Sleep Trend — Last 7 Days'>
        <div className='h-40'>
          {slpData.length > 0 && (
            <ResponsiveContainer width='100%' height='100%'>
              <AreaChart data={slpData} margin={{ top: 5, right: 8, bottom: 0, left: -16 }}>
                <CartesianGrid {...GRID_PROPS} />
                <XAxis dataKey='x' {...AXIS_PROPS} />
                <YAxis domain={[3, 9]} {...AXIS_PROPS} />
                <Tooltip {...TOOLTIP_PROPS} />
                <Line
                  dataKey='base'
                  name='Baseline'
                  stroke='var(--color-success)'
                  strokeOpacity={0.4}
                  strokeWidth={1.5}
                  dot={false}
                  {...NO_ANIM}
                />
                <Area
                  type='monotone'
                  dataKey='sleep'
                  name='Sleep (h)'
                  stroke='var(--color-info)'
                  fill='var(--color-info)'
                  fillOpacity={0.12}
                  strokeWidth={2}
                  {...NO_ANIM}
                />
              </AreaChart>
            </ResponsiveContainer>
          )}
        </div>
      </Panel>
    </Grid>
  );
};
